<template>
  <transition name="fade">
    <new-message-mobile v-if="isUnReadMessage" />
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <template v-if="type != 'empty'">
    <div class="fx">
      <ul class="fxhead">
        <li class="menu"><a @click="side=!side"><em></em><span>메뉴</span></a></li>
        <li class="login" :class="{'on': userData && $route.meta.gnbMenu === 'myinfo'}">
          <a @click="goPageByName(userData ? 'myinfo' : 'mobileLogin')">
            <em></em>
            <span>{{ userData ? $t('front.common.mypage') : $t('front.gnb.login') }}</span>
          </a>
        </li>
        <li class="home" :class="{'on': $route.meta.gnbMenu === 'main'}"><a @click="onClickMobileHome"><em></em><span>홈</span></a></li>
        <li class="event" :class="{'on': $route.name === 'event'}"><a @click="goPageByName('event')"><em></em><span>이벤트</span></a></li>
        <li class="favorite"><a @click="goPageByName('mobileMain')"><em></em><span>즐겨찾기</span></a></li>
        <!-- <li class="msg" :class="{'on': $route.meta.gnbMenu === 'msg'}"><a @click="goPageByName('msg')"><em></em><span>{{$t('front.mypage.message')}}</span></a></li>
        <li class="home" :class="{'on': $route.meta.gnbMenu === 'betList'}"><a @click="goPageByName('betList')"><em></em><span>{{$t('front.mypage.betList')}}</span></a></li>
        <li class="my" :class="{'on': $route.meta.gnbMenu === 'myinfo'}"><a @click="goPageByName('myinfo')"><em></em><span>{{$t('front.common.mypage')}}</span></a></li> -->
      </ul>
    </div>

    <header :class="{ auroraMemberHeader: userData }">
      <!--div class="noticeWrap">
        <div class="notice"><em>{{$t('front.common.notices')}}</em><span>{{$t('front.header.msg')}}</span></div>
        <div class="langbtn" @click="openLang()">
          <button class="langdropbtn" >
            <template v-if="$i18n.locale === 'ko'">
              <img src="@/assets_mobile/img/korea.png" /><span class="langsp">KO</span>
            </template>
            <template v-if="$i18n.locale === 'en'">
              <img src="@/assets/img/eng.png" /><span class="langsp">EN</span>
            </template>
            <template v-if="$i18n.locale === 'vn'">
              <img src="@/assets/img/vn.svg" /><span class="langsp">VN</span>
            </template>
            <img class="langbtnb" src="@/assets_mobile/img/langbtn.png" />
          </button>
          <div class="langdropdown" v-if="isOpenLang">
            <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')">KR</a>
            <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')">EN</a>
            <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')">VN</a>
          </div>
        </div>
      </div-->
      <div class="header auroraMobileHeader">
        <h1 class="logo auroraMobileLogo">
          <a @click="goPageByName('mobileMain')"><span class="auroraLogoCutout" role="img" aria-label="AURORA"></span></a>
        </h1>
        <div class="auroraMobileActions">
          <div class="langbtn auroraMobileLang" @click="openLang()">
            <button class="langdropbtn" type="button">
              <template v-if="$i18n.locale === 'ko'">
                <img src="@/assets/img/korea.svg" /><span class="langsp">KR</span>
              </template>
              <template v-if="$i18n.locale === 'en'">
                <img src="@/assets/img/en.svg" /><span class="langsp">EN</span>
              </template>
              <template v-if="$i18n.locale === 'vn'">
                <img src="@/assets/img/vn.svg" /><span class="langsp">VN</span>
              </template>
            </button>
            <div class="langdropdown" v-if="isOpenLang">
              <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click.prevent="changeLocale('ko')"><img src="@/assets/img/korea.svg" /><span>KR</span></a>
              <a href="#" :class="{'on': $i18n.locale === 'en'}" @click.prevent="changeLocale('en')"><img src="@/assets/img/en.svg" /><span>EN</span></a>
              <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click.prevent="changeLocale('vn')"><img src="@/assets/img/vn.svg" /><span>VN</span></a>
            </div>
          </div>
          <template v-if="!userData">
            <a class="auroraMobileBtn login" @click="goPageByName('mobileLogin')">{{ $t('front.gnb.login') }}</a>
            <a class="auroraMobileBtn join" @click="goPageByName('mobileJoin')">{{ $t('front.common.signup') }}</a>
          </template>
          <template v-else>
            <a class="auroraMobileBtn login" @click="signOut()">{{ $t('front.common.logout') }}</a>
          </template>
          <button type="button" class="auroraMobileMenu" @click="side=!side">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      <div v-if="userData">
        <div class="logininfowrap2">
          <ul class="mym">
            <li class="myc">
              <img src="@/assets_mobile/img/icon_user.svg" />
              <span>
                  <em>{{$t('front.common.nickName')}}</em>
                  {{userData.memNick}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('charge')">
              <img src="@/assets/img/left/icon_left_in.svg" />
              <span>
                  <em>{{$t('front.cash.haveCash')}}</em>
                  {{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('point')">
              <img src="@/assets/img/left/icon_left_point.svg" />
              <span>
                  <em>{{$t('front.cash.nav4')}}</em>
                  {{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('msgMain')">
              <img src="@/assets/img/left/icon_left_msg.svg" />
              <span>
                  <em>{{$t('front.mypage.message')}}</em>
                  {{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}
              </span>
            </li>
          </ul>
          <div class="logininfowrap">
            <a class="mloginbtn" :href="`https://${partnerDomain}/partnerMain`" target="_blank" v-if="userData.isPartnerMember && userData.isPartnerMember === 'Y'">{{$t('front.common.partner')}}</a>
            <a class="mloginbtn" @click="signOut()">{{$t('front.common.logout')}}</a>
          </div>
        </div>
      </div>
      <div v-if="false" class="topbanner">
        <div class="topbannerin">
            <div class="speakerIcon"><img src="@/assets/img/icon_mega.svg"/></div>
            <span class="">{{ flowNotice }}</span>
        </div>
      </div>
    </header>
    <!--a @click="goBack" class="back"><img src="@/assets_mobile/img/back.png" /></a>
    <a class="sideMenu" @click="side=!side" :class="{'out': side}"><em></em></a-->
    <transition name="side">
       <nav v-if="side">
         <div class="nav-wrap">
            <div class="nav-head">
               <div class="header">
                 <h1 class="logo"><a @click="goPageByNamez('mobileMain')"><span class="auroraLogoCutout" role="img" aria-label="AURORA"></span></a></h1>
                 <!--a v-if="userData" @click="goPageByNamez('msgMain')" class="mmsg"><img src="@/assets_mobile/img/message_off.png" /><span class="mgsn">{{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}</span></a>
                 <ul class="minfo" v-if="userData">
                   <li>
                      <span>{{userData.memNick}}</span>
                   </li>
                   <li>
                      <em>₩</em>
                      <span>{{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}</span>
                   </li>
                   <li>
                      <span>{{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}</span>
                   </li>
                   <li @click="goPageByName('point')">
                      <em>P</em>
                      <span>{{userData.pointAmt ? thousand(userData.pointAmt.toString()): 0}}</span>
                   </li>
                 </ul>
                 <div v-if="!userData">
                   <a class="mloginbtn" @click="goPageByNamez('mobileJoin')">JOIN</a>
                   <a class="mloginbtn on" @click.stop="goPageByNamez('mobileLogin')">LOGIN</a>
                 </div-->
               </div>
               <a class="sideMenu" @click="side=!side" :class="{'in': side}"><img src="@/assets/img/icon_x.svg" /></a>
            </div>
            <div class="nav-con">
               <ul>
                  <li>
                      <a @click="goPageByNamez('charge')">
                         <img src="@/assets/img/left/icon_left_in.svg" />
                         <span>{{$t('front.common.deposit')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('exchange')">
                         <img src="@/assets/img/left/icon_left_out.svg" />
                         <span>{{$t('front.common.withdrawal')}}</span>
                      </a>
                  </li>
               </ul>
               <ul>
                  <li>
                      <a @click="goPageByNamez('noticeList')">
                         <img src="@/assets/img/left/icon_left_notice.svg" />
                         <span>{{$t('front.common.notice')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('qnaList')">
                         <img src="@/assets/img/left/icon_left_ask.svg" />
                         <span>{{$t('front.common.qna')}}</span>
                      </a>
                  </li>
                  <!-- <li>
                      <a @click="goPageByNamez('event')">
                         <img src="@/assets/img/left/icon_left_ask.svg" />
                         <span>{{$t('front.board.event')}}</span>
                      </a>
                  </li> -->
                  <!-- <li>
                      <a @click="goPageByNamez('faq')">
                         <img src="@/assets/img/left/icon_left_faq.svg" />
                         <span>{{$t('front.common.faq')}}</span>
                      </a>
                  </li> -->
               </ul>
               <ul>
                  <li>
                      <a @click="goPageByNamez('betList')">
                         <img src="@/assets/img/left/icon_left_bet.svg" />
                         <span>{{$t('front.mypage.betList')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('point')">
                         <img src="@/assets/img/left/icon_left_point.svg" />
                         <span>{{$t('front.common.point')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('msg')">
                         <img src="@/assets/img/left/icon_left_msg.svg" />
                         <span>{{$t('front.mypage.message')}}</span>
                      </a>
                  </li>
                  <li>
                      <a v-if="userData" @click="goPageByNamez('info')">
                         <img src="@/assets/img/left/icon_left_info.svg" />
                         <span>{{$t('front.mypage.memInfoModify')}}</span>
                      </a>
                  </li>
                  <template v-if="userData">
                    <li v-if="userData.isPartnerMember && userData.isPartnerMember === 'Y'">
                        <a :href="`https://${partnerDomain}/partnerMain`" target="_blank" >
                          <img src="@/assets/img/left/icon_left_info.svg" />
                          <span>{{$t('front.common.partner')}}</span>
                        </a>
                    </li>
                  </template>
                  <!-- <li><a @click="onClickTM()"><img src="@/assets/img/left/icon_left_out.svg" /><span>통합머니 전환</span></a></li> -->
               </ul>
               <ul>
                  <li>
                      <a v-if="userData" @click="signOut()">
                         <img src="@/assets/img/icon_logout.svg" />
                         <span>{{$t('front.common.logout')}}</span>
                      </a>
                  </li>
               </ul>
               <!-- <ul class="sns" v-if="siteOption">
                <li>
                    <a @click="siteOption['sns1Link']">
                      <img src="@/assets/img/telegram.svg" />
                      <span>{{siteOption['sns1']}}<em>{{siteOption['sns1Id']}}</em></span>
                    </a>
                </li>
              </ul> -->
            </div>
          </div>
       </nav>
    </transition>
  </template>
</template>

<script>
import { mapState } from 'vuex'
import NewMessageMobile from '@/components/member/MessageMobile.vue'
import TMmodal from '@/components/common/TotalMoney.vue'
import { getFlowNotice } from '@/api/main'
import { getPartnerDomain } from '@/libs/constants'

export default {
  name: 'Header',
  components: { TMmodal, NewMessageMobile },
  props: [
    'type'
  ],
  data () {
    return {
      isOpenLang: false,
      side: false,
      TMOpen: false,
      flowNotice: ''
    }
  },
  watch: {
    async userData (newVal) {
      if (newVal) {
        this.getFlowNotice()
      }
    }
  },
  computed: {
    ...mapState([
      'userData',
      'unReadMessageCount',
      'siteOption'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      return getPartnerDomain()
    },
    partnerPageLink () {
      return 'http://ptn.' + location.host
    }
  },
  mounted () {
    if (this.userData) {
      this.getFlowNotice()
    }
    this.emitter.on('openLogin', this.openMobileLogin)
    this.emitter.on('openSignup', this.openMobileSignup)
  },
  beforeUnmount () {
    this.emitter.off('openLogin', this.openMobileLogin)
    this.emitter.off('openSignup', this.openMobileSignup)
  },
  methods: {
    onClickMobileHome () {
      if (this.$route.name === 'mobileMain') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        return
      }
      this.goPageByName('mobileMain')
    },
    openMobileLogin () {
      this.goPageByName('mobileLogin')
    },
    openMobileSignup () {
      this.goPageByName('mobileJoin')
    },
    getFlowNotice () {
      getFlowNotice({}).then(res => {
        // console.log('flow', res)
        const result = res.data
        if (result.resultCode === '0') {
          this.flowNotice = result.data.content
        }
      })
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    openLang () {
      this.isOpenLang = !this.isOpenLang
    },
    onLogOut () {
      this.$root.signOut()
      this.$router.push({ name: 'main' })
      // location.reload()
    },
    goPageByNamez (name, params) {
      const query = { name: name }
      if (params) {
        query.params = params
      }
      this.$router.push(query)
      this.side = !this.side
    }
  }
}
</script>

<style scoped src="@/styles_mobile/header.css"></style>
<style scoped src="@/styles_mobile/common.css"></style>
<style scoped src="@/styles_mobile/swiper.min.css"></style>
<style scoped src="@/styles_mobile/subcommon.css"></style>
